<app-auth-shell tagline="Your worlds, your party, your story.">
  <div class="af-head">
    <h1>Create your account</h1>
    <p>Free to start. Build worlds, create characters and play with friends.</p>
  </div>

  @if (error) {
    <div class="af-alert af-alert--error" role="alert">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>
      <p>{{ error.message }}</p>
    </div>
  }

  <form class="af-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <div class="af-row">
      <div class="af-field">
        <label class="af-label" for="su-first">First name</label>
        <input id="su-first" class="af-input" type="text" formControlName="first_name" autocomplete="given-name"
          maxlength="100" [class.is-invalid]="invalid('first_name')" [attr.aria-invalid]="invalid('first_name')" autofocus />
        @if (invalid('first_name')) {
          <p class="af-error">Enter your first name.</p>
        }
      </div>
      <div class="af-field">
        <label class="af-label" for="su-last">Last name <span class="af-optional">(optional)</span></label>
        <input id="su-last" class="af-input" type="text" formControlName="last_name" autocomplete="family-name" maxlength="100" />
      </div>
    </div>

    <div class="af-field">
      <label class="af-label" for="su-email">Email</label>
      <input id="su-email" class="af-input" type="email" formControlName="email" autocomplete="email" inputmode="email"
        autocapitalize="off" spellcheck="false" [class.is-invalid]="invalid('email')" [attr.aria-invalid]="invalid('email')" />
      @if (invalid('email')) {
        <p class="af-error">Enter a valid email address.</p>
      } @else {
        <p class="af-hint">We'll send a link to confirm it.</p>
      }
    </div>

    <app-password-field
      [control]="form.controls.password"
      inputId="su-password"
      autocomplete="new-password"
      [showStrength]="true"
      [serverError]="passwordError"
    ></app-password-field>

    <div class="af-field">
      <label class="af-check">
        <input type="checkbox" formControlName="accept_terms" />
        <span>I agree to the <a routerLink="/terms-of-service" target="_blank">Terms of Service</a> and
          <a routerLink="/privacy-policy" target="_blank">Privacy Policy</a>.</span>
      </label>
      @if (invalid('accept_terms')) {
        <p class="af-error">Please accept the Terms of Service and Privacy Policy.</p>
      }
    </div>

    <button type="submit" class="af-btn af-btn--primary" [disabled]="busy">
      @if (busy) { <span class="af-spinner" aria-hidden="true"></span> Creating your account… } @else { Create account }
    </button>
  </form>

  <p class="af-foot">Already have an account? <a class="af-link" routerLink="/login">Sign in</a></p>
</app-auth-shell>
